export const breakpoints = {
  large: 1200,
  medium: 992,
  small: 767,
  extraSmall: 479,
  navMainLarge: 1070,
}
